export default "__VITE_ASSET__CPfL8xPY__"